import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Fade, IconButton, LinearProgress, ListItemIcon, Menu, MenuItem, Paper, Slide, TextField, Typography } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import * as send from '../../../lib/analytics/send';
import { needPremium } from '../../needPremium';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddNewWatchlist = ({ handleNewWatchlistName, dataEventFrom, showPricingBanner, isLoggedin }) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [name, setName] = React.useState('');
  const [error, setError] = React.useState(false);
  const [invalidChar, setInvalidChar] = React.useState('');
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  // const handleNameChange = (event) => {
  //   const inputValue = event.target.value;
  //   if (inputValue.length > 29) {
  //     setError(true);
  //     setInvalidChar('');
  //   } else {
  //     const invalid = inputValue.match(/[^a-zA-Z#$(*)\s]/);
  //     if (invalid) {
  //       setError(true);
  //       setInvalidChar(invalid[0]);
  //     } else {
  //       setError(false);
  //       setInvalidChar('');
  //     }
  //   }
  //   setName(inputValue);
  // };

  const handleNameChange = (event) => {
    const inputValue = event.target.value;

    // Check if the input starts with a space
    if (inputValue.startsWith(' ')) {
      setError(true);
      setInvalidChar('Space as the first character is not allowed');
    } else {
      // Allow all characters
      setError(false);
      setInvalidChar('');
    }

    // Update the name state
    setName(inputValue);
  };

  const handleWatchlistDialog = (e) => {
    if (isLoggedin) {
      send.uevent(e); setOpenDialog(true); setAnchorEl(null);
    } else {
      showPricingBanner(e, `add-new-watchlist-event-${dataEventFrom}`)
    }
  };

  const handleDialogClose = () => { setOpenDialog(false); };

  return (
    <>
      <Button
        size="small"
        disableElevation
        variant="contained"
        onClick={handleWatchlistDialog}
        sx={{ textTransform: 'none', mx: 0, minWidth: '100px', fontSize: '.875rem', my: matches ? 0 : 1, '& .MuiButton-startIcon': { pointerEvents: 'none' } }}
        startIcon={<AddRoundedIcon sx={{ pointerEvents: 'none' }} />}
        data-event-name="new-watchlist" data-event-category={dataEventFrom} data-event-label="dialog-open"
      >
        {matches ? `New Watchlist` : `Add New`}
      </Button>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth="xs"
        onClose={handleDialogClose}
        aria-describedby="add-new-watchlist-dialog"
      >
        <DialogTitle sx={{ mt: 1, pb: 0 }}>{`Create Watchlist`}</DialogTitle>
        <DialogContent>
          <Box
            // component="form"
            sx={{
              '& .MuiTextField-root': { mt: 1, width: { md: '44ch', xs: '100%', sm: '100%' } },
            }}
            noValidate
            autoComplete="off"
          // onSubmit={(e) => { e.preventDefault(); handleNewWatchlistName(name); setOpenDialog(false); }}
          >
            <TextField
              error={error}
              required
              id="list-required"
              label="New watchlist name"
              helperText={
                error
                  ? invalidChar
                    ? invalidChar
                    : 'Use 29 characters or fewer'
                  : ''
              }
              value={name}
              onChange={handleNameChange}

              autoFocus
              margin="dense"
              type="text"
              fullWidth
              variant="standard"
              inputProps={{ maxLength: 30 }} // Limit the input to 100 characters

            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ mb: 1, pt: 0 }}>
          <Button sx={{ textTransform: 'none', mr: 2 }} onClick={handleDialogClose}>Cancel</Button>
          <Button variant="contained" sx={{ textTransform: 'none', mr: 2 }} onClick={() => { handleNewWatchlistName(name); setOpenDialog(false); }} disabled={name === "" || error}>Create</Button>
        </DialogActions>
      </Dialog>
    </>);
}
export default needPremium(AddNewWatchlist)
